var map = {
	"./AllSpeed.svg": 1457,
	"./AttackUp.svg": 6020,
	"./AttackUpCold.svg": 7742,
	"./AttackUpHot.svg": 2710,
	"./AttackUpThunderstorm.svg": 8001,
	"./DefenseUp.svg": 1041,
	"./FlameGuard.svg": 1058,
	"./GloomHeal.svg": 3292,
	"./Glow.svg": 2603,
	"./Heart Half.svg": 9540,
	"./Heart Quarter.svg": 5390,
	"./Heart.svg": 5423,
	"./LifeMaxUp.svg": 8552,
	"./NotSlippy.svg": 2361,
	"./ResistCold.svg": 2775,
	"./ResistElectric.svg": 8965,
	"./ResistGloom.svg": 4261,
	"./ResistHot.svg": 8762,
	"./Rupee.svg": 1551,
	"./Stamina1.svg": 87,
	"./Stamina2.svg": 3211,
	"./Stamina3.svg": 5435,
	"./Stamina4.svg": 7557,
	"./Stamina5.svg": 2960,
	"./StaminaRegen.svg": 5362,
	"./StaminaUp.svg": 8692,
	"./StaminaUp1.svg": 6449,
	"./StaminaUp2.svg": 3532,
	"./StaminaUp3.svg": 2505,
	"./StaminaUp4.svg": 8196,
	"./StaminaUp5.svg": 4480,
	"./StealthUp.svg": 4077,
	"./SwimSpeedUp.svg": 9518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7942;